var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4642 24.4576C7.17225 24.4576 2.07167 19.4461 2.07167 13.2542C2.07167 7.06222 7.17225 2.04068 13.4642 2.04068C19.7562 2.04068 24.8578 7.06222 24.8578 13.2542C24.8578 19.4461 19.7562 24.4576 13.4642 24.4576ZM31.698 30.2595L23.4364 22.127C25.599 19.7762 26.9285 16.6752 26.9285 13.2542C26.9285 5.93186 20.9006 0 13.4642 0C6.02789 0 0 5.93186 0 13.2542C0 20.5665 6.02789 26.4983 13.4642 26.4983C16.6772 26.4983 19.6242 25.388 21.9389 23.5374L30.2335 31.6999C30.6386 32.1 31.2938 32.1 31.698 31.6999C32.1031 31.3098 32.1031 30.6596 31.698 30.2595Z",
    fill: "#6D6D6D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.d7055c319dce68836362272aa59bd61c.svg";
export { ForwardRef as ReactComponent };